import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClinicManagementRoutingModule } from './clinic-management-routing.module';
import { ClinicManagementComponent } from './clinic-management/clinic-management.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SubscriptionCardComponent } from './subscription-card/subscription-card.component';
import { SwiperModule } from 'swiper/angular';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    ClinicManagementComponent,
    SubscriptionCardComponent,
  ],
  imports: [
    CommonModule,
    ClinicManagementRoutingModule,
    LocalizeRouterModule,
    TranslateModule,
    SwiperModule,
    SharedModule,
    FormsModule,
  ]
})
export class ClinicManagementModule { }
